import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'environments/environment';
import { Cobertura } from '../models/cobertura';
import { Planes } from '../models/planes';

const BACKEND_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class PlanService {

  constructor(private http: HttpClient) { }

  private planesSub = new BehaviorSubject<Planes>({
    fallSumaPeso: 0,
    fallSumaDolar: 0,
    fallSumaUdi: 0,
    fallPrimaPeso: 0,
    fallPrimaDolar: 0,
    fallPrimaUdi: 0,

    exenPrimaPeso: 0,
    exenPrimaDolar: 0,
    exenPrimaUdi: 0,

    pagoAdSumaPeso: 0,
    pagoAdSumaDolar: 0,
    pagoAdSumaUdi: 0,
    pagoAdPrimaPeso: 0,
    pagoAdPrimaDolar: 0,
    pagoAdPrimaUdi: 0,

    conyuSumaPeso: 0,
    conyuSumaDolar: 0,
    conyuSumaUdi: 0,
    conyuPrimaPeso: 0,
    conyuPrimaDolar: 0,
    conyuPrimaUdi: 0,

    mAcciSumaPeso: 0,
    mAcciSumaDolar: 0,
    mAcciSumaUdi: 0,
    mAcciPrimaPeso: 0,
    mAcciPrimaDolar: 0,
    mAcciPrimaUdi: 0,

    mPerOrgSumaPeso: 0,
    mPerOrgSumaDolar: 0,
    mPerOrgSumaUdi: 0,
    mPerOrgPrimaPeso: 0,
    mPerOrgPrimaDolar: 0,
    mPerOrgPrimaUdi: 0,

    mColeSumaPeso: 0,
    mColeSumaDolar: 0,
    mColeSumaUdi: 0,
    mColePrimaPeso: 0,
    mColePrimaDolar: 0,
    mColePrimaUdi: 0,

    cancerSumaPeso: 0,
    cancerSumaDolar: 0,
    cancerSumaUdi: 0,
    cancerPrimaPeso: 0,
    cancerPrimaDolar: 0,
    cancerPrimaUdi: 0,

    enfGravSumaPeso: 0,
    enfGravSumaDolar: 0,
    enfGravSumaUdi: 0,
    enfGravPrimaPeso: 0,
    enfGravPrimaDolar: 0,
    enfGravPrimaUdi: 0,

    desempPrimaPeso: 0,
    desempPrimaDolar: 0,
    desempPrimaUdi: 0,

    funeSumaPeso: 0,
    funeSumaDolar: 0,
    funeSumaUdi: 0,
    funePrimaPeso: 0,
    funePrimaDolar: 0,
    funePrimaUdi: 0,

    moneda: 'x',
  });

  obtenerPlazos(plan: string): Observable<any> {
    const params = new HttpParams().set('plan', plan);
    return this.http.get(BACKEND_URL + '/tarifas/', { params: params });
  }

  obtenerValoresMancomunados(edad: string, edadMancomunado: string): Observable<any> {
    const params = new HttpParams().set('edad', edad).set('edadMancomunado', edadMancomunado);
    return this.http.get(BACKEND_URL + '/mancomunados/', { params: params });
  }
  obtenerTarifasCoberturas(cobertura: Cobertura): Observable<any> {
    return this.http.post<Cobertura>(BACKEND_URL + '/tarifas/', cobertura);
  }

  obtenerTarifaCobertura(cobertura: Cobertura): Observable<any> {
    return this.http.post<Cobertura>(BACKEND_URL + '/tarifas/' + cobertura.cobertura, cobertura);
  }

  obtenerDescuentos(): Observable<any> {
    return this.http.get(BACKEND_URL + '/descuentos/');
  }

  obtenerValorUdi(): Observable<any> {
    const params = new HttpParams().append('moneda', 'Udi').append('serie', 'SP68257');
    return this.http.get(BACKEND_URL + '/divisas/', { params: params });
  }

  obtenerValorDolar(): Observable<any> {
    const params = new HttpParams().append('moneda', 'Dolar').append('serie', 'SF60653');
    return this.http.get(BACKEND_URL + '/divisas/', { params: params });
  }


  /**
   * Envia el ultimo valor al stream del observable.
   * @param prospecto a setear.
   */
  public setPlanes(planes: Planes): void {
    this.planesSub.next(planes);
  }

  /**
   * Obtenemos el observable de los generales del prospecto.
   */
  public getPlanes(): Observable<Planes> {
    return this.planesSub.asObservable();
  }
}
